import React, {useState, useEffect} from 'react';
import {
    Backdrop,
    Box,
    Button,
    Chip,
    CircularProgress,
    Container,
    ExpansionPanel,
    ExpansionPanelSummary,
    ExpansionPanelDetails,
    Grid,
    Paper,
    TextField,
    Typography,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SyncIcon from '@material-ui/icons/Sync';
import {Alert, Autocomplete} from '@material-ui/lab';
import useStyles from '../styles/styles';
import {useMutation, useQuery} from '@apollo/react-hooks';
import {gql} from 'apollo-boost';
import {navigate} from '@reach/router';
import _ from 'lodash';
import useFormInputs from "../hooks/useFormInputs";
import getEnvironment from "../utils/getEnvironment";
import TrafficSourcesTable from '../components/TrafficSource/TrafficSourcesTable';

const TrafficSources = () => {
    const classes = useStyles();
    const [variables, setVariables] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const onSubmit = () => {
        const finalInputs = _.omitBy(inputs, _.isEmpty);
        setIsLoading(true);
        setVariables(finalInputs);
    };
    const env = getEnvironment();
    const {clearInput, clearAllInputs, inputs, setInputs, handleInputChange, handleSubmit} = useFormInputs(onSubmit);

    // TODO May not be needed?
    // const {loading: allOfferLoading, error: allOfferError, data: allOfferData, refetch: allOfferRefetch} = useQuery(gql`
    //     query AllTrafficSources {
    //         allOffer {
    //             id
    //             offerName
    //             advertiserId
    //             offerUrls {
    //                 id
    //                 name
    //                 url
    //                 offerId
    //                 offerUrlQueryParameters {
    //                     parameterName
    //                     constantValue
    //                     sourceData
    //                 }
    //             }
    //         }
    //     }
    // `, {
    //     notifyOnNetworkStatusChange: true,
    //     client: useCustomApolloClient()
    // });

    const {loading, error, data, refetch} = useQuery(gql`
        query AllTrafficSources {
            allTrafficSource {
                nodes {
                    id
                    name
                    channel
                    createdAt
                    origin
                    medium
                    sourceUrl
                    offerUrl
                    legacyZoneId
                    legacyPromoId
                    legacyOfferId
                    affiliate {
                        id
                        name
                        key
                        legacyPublisherId
                    }
                    payoutStrategy {
                        id
                        enum
                    }
                    minimumPrice
                    maximumPrice
                    internal
                    aggregatorOnly
                    timeout
                    isListManageable
                    isTest
                    proxyToOlp
                    splitTest
                    timeout
                    multiOffer
                    multiConversion
                    includeS3InSource
                    unsoldFeed
                    soldFeed
                    rootPingTree
                    priceRejectMins {
                        mins
                    }
                    offer {
                        id
                        advertiserId
                        offerName
                        offerUrls {
                            id
                            active
                            urlPath
                            name
                            httpMethod
                            offerId
                            offerUrlQueryParameters {
                                constantValue
                                id
                                offerUrlId
                                parameterName
                                sourceData
                            }
                        }
                        offerNote {
                            id
                            notes
                            offerId
                        }
                    }
                }
            }
            allAffiliate {
                nodes {
                    id
                    name
                }
            }
            allAdvertiser {
                name
            }
        }
    `, {
        notifyOnNetworkStatusChange: true,
    });

    const [updateTrafficSourcesFromTest, {loading: syncLoading, data: syncDataResp}] = useMutation(gql`
        mutation syncData {
            updateTrafficSourcesFromTest
        }
    `);

    useEffect(() => {
        if (isLoading) {
            setTimeout(() => setIsLoading(false), 3000);
        }
    }, [isLoading])

    useEffect(() => {
        if (syncDataResp && syncDataResp.updateTrafficSourcesFromTest) {
            setTimeout(() => setSuccess(false), 3000);
            refetch();
        }
    }, [syncDataResp]);

    const handleChange = (name, value) => {
        setInputs(inputs => ({
            ...inputs,
            [name]: value ? value.name : ''
        }));
    };
    if (isLoading || syncLoading) {
        return (
            <Backdrop className={classes.backdrop} open={true}>
                <CircularProgress color="inherit"/>
            </Backdrop>
        );
    }

    return (
        <>
            <Typography variant="h2">
                Traffic Sources
            </Typography>
            <form id="traffic-source-form" onSubmit={handleSubmit}>
                <ExpansionPanel expanded style={{marginBottom: '20px'}}>
                    <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography variant="h5">Filter Traffic Sources</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.filter}>
                        <Container maxWidth={false}>
                            <Box className={classes.filterBox} style={{marginTop: 0}}>
                                <Chip
                                    label="Default Options"
                                    className={classes.filterSectionLabels}
                                />
                                <Grid container spacing={2}>
                                    <Grid item xs={9}>
                                        <TextField
                                            id="search"
                                            name="trafficSourceId"
                                            label="Search by UUID"
                                            value={inputs.trafficSourceId || ''}
                                            onChange={handleInputChange}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Button variant="contained" color="secondary" fullWidth onClick={() => {
                                            window.open(`/info/traffic-sources/${inputs.trafficSourceId}`);
                                            clearInput('trafficSourceId');
                                        }}>
                                            Find Traffic Source
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box className={classes.filterBox}>
                                <Chip
                                    label="Filter Options"
                                    className={classes.filterSectionLabels}
                                />
                                <Grid container spacing={2}>
                                    <Grid item xs={3}>
                                        {data && data.allAffiliate.nodes.length ? (
                                            <Autocomplete
                                                className={classes.autoComplete}
                                                name="affiliateName"
                                                value={inputs.affiliateName || null}
                                                onChange={(e, val) => handleChange('affiliateName', val)}
                                                options={data.allAffiliate.nodes}
                                                getOptionLabel={option => {
                                                    if (_.has(option, 'name')) {
                                                        return option.name;
                                                    }
                                                    return option;
                                                }}
                                                renderInput={params => <TextField {...params} label="Affiliates"
                                                                                  variant="outlined" fullWidth/>}
                                            />
                                        ) : null}
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            id="promoId"
                                            name="promoId"
                                            label="Search by Promo Id"
                                            value={inputs.promoId || ''}
                                            onChange={handleInputChange}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            id="zoneId"
                                            name="zoneId"
                                            label="Search by Zone Id"
                                            value={inputs.zoneId || ''}
                                            onChange={handleInputChange}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            id="tsLabel"
                                            name="trafficSourceName"
                                            label="Search by Traffic Source Name"
                                            value={inputs.trafficSourceName || ''}
                                            onChange={handleInputChange}
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box paddingTop={3}>
                                <Grid container spacing={2} justify="center" alignItems="center">
                                    <Grid item xs={12} sm={6} md={4} lg={3}>
                                        <Button type="submit" variant="contained" color="secondary" fullWidth>
                                            Filter Results
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4} lg={3}>
                                        <Button onClick={() => {
                                            clearAllInputs();
                                            setVariables({});
                                        }} variant="outlined" color="secondary" fullWidth>
                                            Clear Filters
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Container>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            </form>
            <Grid container direction="row" justify="space-between" alignItems="center" style={{marginBottom: '15px'}}>
                <Grid item xs={4}>
                </Grid>
                <Grid item xs={4} style={{textAlign: 'right'}}>
                    {env === 'test' ? (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => navigate('/info/traffic-sources/add')}
                            startIcon={<AddIcon/>}>
                            ADD TRAFFIC SOURCE
                        </Button>
                    ) : (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                setSuccess(true);
                                updateTrafficSourcesFromTest();
                            }}
                            startIcon={<SyncIcon/>}>
                            Sync Traffic Sources From Test
                        </Button>
                    )}
                </Grid>
            </Grid>
            {
                !loading && error ? (
                    <Paper className={classes.paper}>
                        <Alert severity="error">There is an error!</Alert>
                        <pre>{JSON.stringify(error, null, 2)}</pre>
                    </Paper>
                ) : null
            }
            {
                loading ? (
                    <Paper className={classes.paper}>
                        <div className={classes.loadingBar}>
                            <CircularProgress
                                size={50}
                                thickness={4}
                            />
                        </div>
                    </Paper>
                ) : null
            }
            {
                !loading && data && data.allTrafficSource.nodes.length ? (
                    <>
                        {success ? (
                            <Alert severity="success">Traffic Sources are synced!</Alert>
                        ) : null}
                        <TrafficSourcesTable
                            trafficSources={data.allTrafficSource.nodes}
                            variables={variables}
                            refetch={refetch}
                            actions={['refresh', 'view']}
                        />
                    </>
                ) : null
            }
        </>
    )
}

export default TrafficSources;
